import { useEffect } from "react";

import { useThunkDispatch } from "@/redux/dispatcher";
import { load } from "@/redux/modules/api/data/customer/customer.module";
import { useIsClientSide } from "@/utils/hooks/isClient.hook";

const CustomerLoad = () => {
    const isClientSide = useIsClientSide();
    const dispatch = useThunkDispatch();

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        if (isClientSide) {
            dispatch(load());
        }
    }, [isClientSide]);

    return null;
};

export { CustomerLoad };
